import type { IChartData } from './ichartdata';

export class BarChartSeriesItem {
  constructor(public name: string, public value: number) {}
}

export class BarChartData implements IChartData {
  public data: BarChartSeriesItem[] = [];
}
